export const i18fr = {
    settings: "Paramètres",
    consultation_locations: "Lieux de consultations",
    consultation_locations_plural: "Lieu(x) de consultation(s)",
    reasons_for_consultation: "Sous catégorie",
    categories: "Motif d'examen",
    instructions: "Consignes",
    change_aperture_ranges: "Sélection des plages d'ouverture",//SÉLECTION DES PLAGES D’OUVERTURE
    calendar: 'Calendrier',
    modify_category: "modifier un motif d'examen",
    add_category: "Ajouter un motif d'examen",
    validate: "Valider",
    modify: "Modifier",
    success_modified: "modifié avec succès",
    success_added: "ajouté avec succès",
    success_updated: "mise à jour réussie",
    select_doctor: "Sélectionner un médecin",
    select_location: "Sélectionnez votre lieu de consultation",
    select_categoty: "Choisir un motif d'examen",
    select_speciality: "Choisir une spécialité pour l'examen",
    select_service: "Choisir une sous catégorie",
    choose_service_to_make_it_available: `Cliquez les examens à rendre disponibles`,
    passed_date: "La date de rendez-vous est passée. Choisissez une autre date.",
    select_patient: "Choisir un patient",
    enter_addressing: "Saisir l'adresse",
    enter_notes: "Remarques",
    enter_firstname: "Entrez votre prénom",
    enter_dob: "Entrez votre date de naissance",
    enter_lastname: "Entrez le nom de famille",
    enter_ssn: "Numéro de sécurité sociale invalide",
    enter_email: "Entrez l'e-mail",
    notes: "Note permanente",
    reason_consultation: "Sous catégorie",
    addressing: "Adressé par",
    hour: "Horaire",
    create_new_pattern: 'Créer un nouveau motif',
    modify_new_pattern: "Modifier un motif",
    assigner_to_Secretary: 'Attribuer au secrétariat',
    add_a_payment: 'Ajouter un paiement',
    attach_a_document: 'Joindre un document',
    delete_appointment: 'Supprimer le RDV',
    appointment_moved: 'Déplacer le RDV',
    payment_made: 'Payé',
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimé',
    continue: "Continuer",
    appointment_status: "Statut du rendez-vous",
    action: "Action",
    first_appointment: "1er RDV",
    up_coming_appointments: "RDV à venir",
    appointment_completed: "RDV terminé",
    appointment_canceled: "RDV annulé",
    emergency_appointments: "RDV urgent",
    title: 'Titre',
    enter_ur_description: "Entrer une description (uniquement visible en interne)",
    repeat: "Répéter",
    create_new_opening: "Ouvrir un créneau horaire",
    repeat_on: "Répéter",
    ends: "Finir",
    enter_title: "Entrer le titre",
    modify_the_opening_ranges: "Modifier les plages d’ouverture",
    edit_opening: "Modifier l'ouverture",
    view_opening: "ouverture de vue",
    status: "Statut",
    view_appointment: "Voir le rendez-vous",
    edit_appointment: "Modifier le rendez-vous",
    please_note: "VEUILLEZ NOTER",
    select_file: "Choisissez le fichier",
    already_have_slot: "Ce créneau horaire est déjà disponible dans cette plage horaire",
    overlap_opening: "Notez que ce créneau horaire est aussi sélectionné sur l'agenda ",
    this: 'cet ',
    these: 'ces ',
    outside_opening_hours: "Votre rendez-vous est en dehors des horaires d'ouverture.",
    selected_past_day: "La date sélectionnée est révolue",
    choose_category: "Pour quel motif d’examen souhaitez-vous prendre rendez-vous ? ",
    choose_speciality: "Choisissez une spécialité pour votre consultation",
    choose_service: "Choisissez un motif d'examen",
    for_someone_else: "+ Pour quelqu'un d'autre",
    who_appointment: "Pour qui prenez-vous ce rendez-vous ?",
    only_one_patient: "Un rendez-vous est pris pour une seule personne",
    authorized_personal: "Je déclare être le représentant légal de mon proche, ou être autorisé à utiliser les services Hypokrate pour gérer ses données médicales en son nom.",
    previous_step: "Étape précédente",
    appointment: "Rendez-vous",
    appointment_make: "Prise de rendez-vous",
    consultation_mode: "Mode de consultation",
    consultation_category: "motif d'examen pour votre consultation",
    me: "moi",
    create_appointment: 'Prendre un rendez-vous',
    Mon: "Lun",
    Tues: "Mar",
    Wednes: "Mer",
    Thurs: "Jeu",
    Fri: "Ven",
    Satur: "Sam",
    Sun: "Dim",
    never: "Jamais",
    the: "Jusqu'au",
    visiable_to_patient: "Visible pour le patient",
    visiable_to_me: "Visible uniquement par moi",
    add_service: "Ajouter un service",
    All: "Tous",
    choose_file: "Choisir le fichier",
    no_file_chosen: "Aucun fichier choisi",
    months: 'mois',
    hours: 'heures',
    min: 'minutes',
    days: 'jours',
    minutes: "minutes",
    consultation_type: "Mode de consultation",
    in_office: 'En Cabinet',
    in_teleconsultation: "En téléconsultation",
    at_home: "A domicile",
    enter: "Entrer",
    are_u_sure: "Êtes-vous sûr(e) de vouloir continuer ?",
    name: 'Nom',
    first_name: 'Prénom',
    social_num: 'Numéro de sécurite sociale',
    dob: 'DDN',
    email: 'Adresse e-mail',
    address: 'Adresse',
    postal_ville: 'Code postal, Ville',
    tele_port: 'Tél portable',
    tele_domicile: 'Tél domicile',
    emergency_num: "Nº d'urgence",
    previous: "précédent",
    next: "suivant",
    date: 'date',
    time: 'heure',
    patient: 'Patient',
    patient_contact_information: "Coordonnées du patient",
    masquer_les_coordonnées_du_patient: "Masquer les coordonnées du patient",
    are_you_sure_you_want_to_delete: "Êtes-vous sûr(e) de supprimer",
    are_you_sure: "Êtes-vous sûr de vouloir",
    inactiver: "Inactiver",
    activer: "Activer",
    category: `Motif d'examen`,
    choose_secretary: "Choisir la secrétaire",
    accept_declaration: "Acceptez la déclaration pour continuer",
    time_slot_busy: "Un autre rendez-vous est actuellement prévu à l'heure que vous avez sélectionnée.",
    confirm: "Confirmer",
    delete_appointment: 'Suppression du rendez-vous ',
    remove_secretary: 'Retirer la secrétaire',
    remove: 'retirer',
    are_you_sure_secretary: 'Êtes-vous certain de vouloir révoquer la secrétaire désignée pour cette nomination ?',
    choose_consultation_mode: 'Choisissez votre mode de consultation',
    select_a_consultaion: 'Sélectionnez une méthode de consultation',
    service_already_exist: "Cet intitulé de sous catégorie existe déjà comme motif d'examen. Choisissez un autre intitulé, ou un autre motif d'examen.",
    category_already_exit: "Cet intitulé de motif d'examen existe déjà dans cette spécialité. Choisissez un autre intitulé ou une autre spécialité.",
    doctor: 'Médecin',
    success: 'Succès',
    failure: 'Échec',
    confirmed_appointment: 'Rendez-vous confirmé',
    you_receive_mail: 'vous avez reçu un email de confirmation',
    choose_patient: 'Choisir un patient',
    search_patient: 'Rechercher un patient',
    no_record: 'Aucun enregistrement trouvé',
    create_patient: 'Créer un nouveau patient',
    pick_slot: "Choisissez I’heure du RDV",
    add_a_new_category: "Ajouter un motif d'examen",
    end_date_precedes_start_date: "La date de fin ne doit pas précéder la date de début",
    api_err_category_cant_delete: "Ce motif d’examen contient différentes sous catégories. Commencez à supprimer ces dernières pour pouvoir supprimer ensuite le motif d’examen.",
    api_err_service_cant_delete: "Ce service est déjà lié aux prises de rendez-vous des ouvertures. Vous ne pouvez pas le supprimer.",
    delete_category: "Supprimer le Motif d'examen",
    delete_reason_for_conslt: "Supprimer les Sous catégorie",
    are_you_sure_status_change: 'Etes-vous sûr de vouloir changer le statut du rendez-vous en ',
    status_change_attende: 'Etes-vous sûr de vouloir mettre le rendez-vous en ',
    status_change_confirmer: 'Etes-vous sûr de vouloir confirmer le rendez-vous',
    status_change_tele: `Etes-vous sûr de vouloir `,
    for_status: 'For Statut : ',
    status_change: 'Modification du statut du rendez-vous',
    secretary_assigned: "RDV m'a assigné",
    upcoming_appointments: 'Rendez-vous à venir',
    past_appointments: 'Rendez-vous passés',
    create_category: "Veuillez créer un motif d'examen dans les paramètres",
    create_service: "Veuillez créer un service dans les paramètres",
    speciality: "Spécialité",
    attach_delete_confirm: 'Confirmation de suppression',
    are_you_sure_attach: 'Êtes-vous sûr de vouloir supprimer la pièce jointe ?',
    color: `couleur`,
    Reason_for_consultation: 'Sous catégorie',
    Duration: 'Durée',
    online_booking: 'Réservation en ligne',
    man: 'Homme',
    women: 'Femme',
    unknown: 'Inconnu',
    add_consultation_place: "Ajouter un lieu de consultation",
    place: 'Lieu',
    facility_name: `Nom de l'établissement`,
    appears_on_medicallink_profile: 'Apparaît sur votre profil MediKaLlink et dans les rappels de rendez-vous',
    postal_address: 'Adresse postale',
    public_practical_info: 'Informations pratiques publiques',
    office_phone_number: 'Numéro de téléphone',
    hide: 'MASQUER',
    fax: 'Fax',
    accessibility: 'Accessibilité',
    elevator: 'Ascenseur',
    floor: 'Étage',
    accessible_entrance: 'Accessible handicapé',
    parking: 'Parking',
    none: 'Aucun',
    operation_hours: `Horaires d'ouverture`,
    add_hours: 'Ajouter une plage horaire',
    of: 'De',
    has: 'à',
    Monday: "Lundi",
    Tuesday: "Mardi",
    Wednesday: "Mercredi",
    Thursday: "Jeudi",
    Friday: "Vendredi",
    Saturday: "Samedi",
    Sunday: "Dimanche",
    office_closed: 'Le cabinet est fermé',
    summary: 'Résumé',
    emergency_contact: `Contact d'urgence`,
    type: 'Type',
    phone_number: 'Numéro de téléphone',
    agenda: `Agenda`,
    agendas: 'Agendas',
    create_new_calendar: `Créer un nouvel agenda`,
    location: `Emplacement`,
    my_place_of_consultation: `Lieu de consultations`,
    other_place_of_consultation: `Autre lieu de consultations`,
    calendar_name: `Nom de l'agenda`,
    personal_phone: 'Numéro de portable personnel',
    direct_phone: 'Ligne directe du praticien',
    secretariat: 'Secrétariat',
    telesecretary: 'Télésecrétaire',
    administrator: 'Administrateur',
    secretary: 'Secrétaire',
    sos_doctor: 'SOS Médecins',
    samu: 'SAMU',
    select: `sélectionner`,
    create_a_new: `Créer un nouvel`,
    edit_a: `modifier un`,
    location_name_empty: 'Le lieu doit être renseigné',
    select_location_address: "Sélectionnez une adresse de localisation dans la liste déroulante.",
    api_err_location_cant_delete: 'Un agenda existe déjà pour cet emplacement, il ne peut donc pas être supprimé.',
    myself: 'Moi-même',
    medical_center: 'Centre médical',
    office: 'Mon Cabinet',
    clinic: 'Clinique',
    hospital: 'Hôpital',
    associated_with: 'Associé à',
    start_end_must_differ: 'Les heures de début et de fin ne peuvent pas être les mêmes',
    association_mandatory: 'Le champ association est obligatoire',
    available: 'Disponible',
    none: 'Aucun',
    display_settings: `Paramètres d'affichage`,
    list_of_proposed_exams: `Liste des examens proposés`,
    floor: 'étage',
    entrance: 'entrée',
    parking: 'parking',
    accessible: 'accessible',
    not_accessible_entrance: 'non accessible aux PMR',
    with: 'avec',
    emergency: 'En cas d’urgence, contactez le 1001',
    contact_info: 'Numéro de téléphone: 1002',
    list_of_proposed_exams: `Liste des examens proposés`,
    present_establishment: `Présentation de l'établissement`,
    add_picture: 'Ajouter des photos',
    chooseMedicin: 'Choisissez un médecin pour votre consultation',
    no_consultation_location: `Aucun lieu de consultation n’est disponible pour le moment`,
    add_a_place: 'Ajouter un lieu',
    no_data: 'Pas de données',
    Next: 'Suivante',
    Previous: 'Précédente',
    map_info: 'Carte et informations d’accès',
    useful_info: 'Informations pratiques',
    presentation_of_establishment: "Présentation de l'établissement",
    opening_hours_contact: 'Horaires d’ouverture et contact',
    hours_of_operation: 'Horaires d’ouverture',
    emergency_contact: 'Contact d’urgence',
    contact_details: 'Coordonnées',
    the_team: 'L’équipe',
    results: 'résultats',
    result: 'résultat',
    research: 'Rechercher',
    search_place: 'Nom, spécialité, établissement.....',
    availability: 'Disponibilité',
    means_payment: 'Moyens de paiement',
    spoken_language: 'Langues parlées',
    choose_consult_date: `Choisissez la date et l'horaire de consultation`,
    no_slot_today: 'Aucun créneau disponible ce jour',
    around_me: 'Autour de moi',
    no_x_is_available_at_the_moment: `Aucun x n'est disponible pour le moment`,
    list_of_exams_offered: 'Liste des examens proposés',
    accepting_new_patients: `Accepter de nouveaux patients`,
    accept_tele_consultation: 'Accepter la téléconsultation',
    minimum_patient_age: 'Âge minimum du patient',
    no_appointment: 'Aucun enregistrement trouvé',
    update: 'Mise à jour',
    waiting_for_confirmation: `Attente de confirmation`,
    adsences_annulations: 'Absences / Annulations',
    confirmed: `Confirmé`,
    RDV_confirmed: `RDV confirmé`,
    INFORMATION: "INFORMATION",
    to_advance: `A avancer`,
    delay: `Retard`,
    arrived: `Arrivé`,
    in_progress: `En cours`,
    finished: `Terminé`,
    paid: `Payé`,
    unjustified_absence: `Absence non justifiée`,
    cancel_by_patient: `Annulé par le patient`,
    switch_tele: 'Passer en téléconsultation',
    cancel_doctor: 'Annulé par le médecin',
    to_postpone_to_prevent: `A reporter`,
    to_be_postponed_forewarned: `A reporter prevenu`,
    want_user_rights_for_this_calendar: "Souhaitez-vous définir les droits des utilisateurs pour cet agenda ?",
    following: 'Suivant',
    create_a: 'Créer un ',
    same_rights_calendar: "Utiliser les mêmes droits pour l'agenda suivant :",
    user: "Utilisateur",
    user_rights_on_the_calendar: "Droits de l'utilisateur sur l'agenda",
    language_spoken: 'Langues parlées',
    patient_must_over_12: 'Les patients doivent être âgés de plus de',
    take_new_patient: 'Ce praticien prend de nouveaux patients',
    take_price: 'Voir les tarifs',
    sector_approved: 'Conventionné secteur 2',
    vital_card: 'Carte vitale',
    blue_card: 'Carte bleue',
    check: 'Chèque',
    who_online_book_reason: 'Qui peut réserver en ligne ?',
    before_appointment: 'avant le rendez-vous',
    opening_reservation: 'Ouverture des réservations',
    booking_times: 'Délais de prise de rendez-vous',
    reservation_closed: 'Fermeture des réservations',
    patient_appointment_criteria: `Les patients pourront prendre rendez-vous pour ce motif {opening} à l'avance, et jusqu'à {close} avant le rendez-vous.`,
    price: 'Prix',
    between: 'Entre',
    notifications: 'Notifications',
    confirm_patient_notification: `Voulez-vous que les patients reçoivent des notifications pour ce RDV ? (E-mails, SMS et notifications push)`,
    from: 'De',
    to: 'À',
    mr: `M.`,
    mrs: 'Mme',
    years: 'ans',
    pin_code: 'NIP',
    enter_teleport: 'Entrez le téléphone portable',
    enter_pincode: 'Veuillez saisir le NIP',
    toStart: 'Commencer',
    stage: 'Étape',
    email_sms_consult_start: 'Un email / sms vous sera envoyé',
    email_sms_consult_start_to_patient: 'Un e-mail / SMS sera envoyé au patient',
    appointment_confirmed_for_at: 'Le rendez-vous est confirmé pour le ',
    note_appointment_id: 'Prenez note de votre identifiant de rendez-vous',
    enter_amount: 'Entrez le montant',
    name_on_card: 'Nom sur la carte',
    credit_card_num: 'Numéro de carte de crédit',
    bank_card: 'Carte bancaire',
    consult_fee: 'Tarif de consultation',
    enter_schedule_date: 'Saisir la date programmée',
    enter_practitioner_name: 'Saisir le nom du praticien référent',
    search_agenda: "Recherche d'agenda",
    add: 'ajouter',
    Back: 'Retour',
    toStart: 'Commencer',
    stage: 'Étape',
    consultation_location_s: 'Lieu(x) de consultation(s)',
    calendar_settings: 'Paramètres du l’agenda',
    days_display_week: 'Jours de la semaine que vous voulez visualiser sur l’agenda',
    visible_to_prac: "(Visible par le praticien uniquement)",
    hours_display_days: 'Heures de la journée que vous souhaitez afficher',
    hours_to: 'heures à',
    hours_per_block_of: 'heures par tranche de ',
    open_folder: 'Ouvrir le dossier',
    research_placeholder: 'Rechercher un professionnel, une spécialité, un établissement...',
    notify_email: 'Il est préférable de renseigner une adresse e-mail ',
    agenda_name: "Nom de l'agenda",
    calendar_rights: "Droits d'accès aux agendas",
    no_access: `pas d'accès`,
    making_and_cancellation_of_appointments: `Prise et Annulation de RDV`,
    total_management: `Gestion totale`,
    view_only: `Vue uniquement`,
    yes: 'Oui',
    No: 'Non',
    no: 'non',
    create_agenda_availability: 'Créer un nouvel agenda',
    skip: 'Passer',
    submit: 'Suivant',
    previous: 'Précédent',
    creating_a_new_calendar: `Création d'un nouvel agenda`,
    edit_calendar: `Modifier Agenda`,
    read_only: `Lecture uniquement`,
    appointment_create: 'Prise de RDV',
    appointment_management: `Prise de RDV + Lecture`,
    apt_mng_message: `Prise de RDV + Messagerie`,
    apt_mng_dossier: `Prise de RDV + Messagerie + Dossier Patient`,
    search: 'Recherche',
    opening: `Ouverture`,
    click_for_reason: "Cliquez ici pour ajouter un motif d'examen",
    calendar_grouping: 'Groupement des agendas',
    view_calendars_side_by_side_in_week_view: 'Vue semaine – Voir les agendas côte à côte',
    display_of_consultation_reasons_in_day_view: 'Vue journée – Afficher les motifs de consultation',
    turn_off_notifications_for_new_online_appointments: 'Désactiver les notifications pour les nouveaux rendez-vous en ligne',
    show_calendar_resources_first: 'Afficher les agenda ressources en premier',
    reservation: "Droits de réservation en ligne",
    more_details: `Voir plus d'horaires`,
    national_diplomas: 'Diplômes nationaux et universitaires',
    experiences: 'Expériences',
    other_formation: 'Autres Formations',
    select_agenda: 'Sélectionnez un agenda',
    prices: 'Tarifs',
    website: 'Site Internet',
    exert_acts: 'Expertises et actes',
    presentation: "Présentation",
    Remarks: 'Remarques',
    less_details: `Voir moins d'horaires`,
    configuration: 'Configuration',
    opening_ranges: "Ouverture consultations & examens",
    opening_ranges_calendar: "Organisation des examens dans l’agenda",
    access_rights: "Droits d'accès",
    consult_access: "Conditions d’accès aux consultations",
    move_appointment: 'Déplacer le RDV',
    cancel_appointment: 'Annuler le RDV',
    delay_appointment: 'Retarder le rendez-vous',
    delay_rdv: 'Retarder le RDV',
    make_early_appointment: 'Prendre rendez-vous plus tôt ?',
    telephone_of_consultation: 'Téléphone du lieu de consultation',
    go_to_consultation: 'Se rendre à la consultation',
    prices_reimbursement: 'Tarifs et remboursement',
    document: 'Document',
    pls_bring_on_visit: `Merci de vous munir de votre carte vitale à jour et, le cas échéant, de votre carte d'assurance maladie ou de votre attestation de droits à jour.`,
    sector_2_approved: 'Agréé Secteur 2',
    no_consultation: "Aucun lieu de consultation ajouté pour l'instant",
    add_a_consultation_location: "Ajouter un lieu de consultation",
    no_speciality_added_yet: "Aucune spécialité ajoutée pour l'instant",
    add_speciality: "Ajouter une spécialité",
    consult_access: "Conditions d’accès aux consultations",
    make_Appointment: 'Prendre rendez-vous',
    hero_title: 'Prenez rendez-vous facilement avec un médecin',
    hero_subtitle: 'Trouvez le professionnel de santé adapté à vos besoins et réservez votre consultation en quelques clics.',
    reason_for_exam: 'Motifs d’examen',
    fees_communication: 'Ces honoraires vous sont communiqués à titre indicatif par le praticien. Ils peuvent varier selon le type de soins finalement réalisés et les actes additionnels nécessaires.',
    add_a_doctor: 'Ajouter un médecin',
    add_a_speciality: 'Ajouter une spécialité',
    where: 'Où',
    create_an_invoice: 'Créer une facture',
    you_have_selected: 'Vous avez sélectionné le',
    confirm_appointment_time: `Confirmez l'heure du rendez-vous`,
    invoice_the_act: "Facturer l’acte",
    invoice_s: "Facture(s)",
    legal_info: 'Informations légales',
    rpps_num: 'Numéro RPPS',
    no_access_appointment_create: "Vous n'avez pas accès pour créer un rendez-vous pour une ",
    no_access_appointment_edit: "Vous n'avez pas accès pour modifier ce rendez-vous",
    no_access_appointment_view: "Vous n'avez pas accès pour voir ce rendez-vous.",
    no_access_appointment_delete: "Vous n'avez pas accès pour supprimer ce rendez-vous",
    no_access_overture_create: `Vous n'avez pas accès pour créer une ouverture pour un `,
    near_me: 'À proximité',
    waiting_for_doc: `En attente de l'approbation du médecin`,
    Accept: 'Accepter',
    reject: 'Rejeter',
    appointment_already_cancelled: 'Votre rendez-vous a été annulé le',
    waiting_list: "Liste d'attente",
    to_be_moved: 'A déplacer',
    add_agenda_service: "Ajouter un motif d'examen",
    no_service_found: "Aucun service trouvé",
    no_service_found_step4: "Vous n'avez ajouté aucun service à l'étape 2.",
    appointment_delay: 'Retard de rendez-vous',
    appointment_early: 'Rendez-vous anticipé',
    retard_accept_time: "Temps de retard accepté",
    logged_as_doctor: "Veuillez noter que votre session actuelle est connectée en tant que médecin. Si vous souhaitez continuer, veuillez vous connecter en tant que patient",
    set_aperture_range: "Définir les plages d'ouverture de vos consultations et examens",
    hours_of_operation: "Horaires d'ouverture",
    existing: "Existant",
    create: 'Creer',
    please_create_availability: 'Veuillez créer une disponibilité',
    info: 'Informations',
    i_create_agenda: "Créer / Modifier mon agenda",
    empty_category_list: `Aucun motif d'examen disponible`,
    empty_agenda_list: 'Aucun agenda disponible',
    empty_service_list: 'Aucun sous catégorie disponible',
    doctors: 'Médecins',
    patients: 'Patients',
    the_agenda: `I'agenda`,
    to_print: 'Imprimer',
    printing_to_list: 'Impression de la liste',
    of: 'De',
    at: 'Au',
    orientation: 'Orientation',
    portrait: 'Portrait',
    landscape: 'Paysage',
    days_t_print: 'Jours à imprimer',
    period_to_print: 'Période à imprimer',
    whole_day: 'Journée entiere',
    morning_only: 'Matin uniquement',
    afternoon_only: 'Apres-midi uniquement',
    show_background_color: 'Afficher la couleur de fond',
    show_icons: 'Afficher les icones',
    show_notes: 'Afficher les notes',
    viewing_contact_information: 'Affichage des infos du contact',
    condensed_display: 'Affichage condense',
    options: 'Options',
    tel: 'Tel',
    delete_location: `Supprimer le Lieu de consultation`,
    list: 'Liste',
    printing_the_calendar: 'Impression du calendrier',
    print_on_a_single_page: 'Imprimer sur une seule page',
    fromSmall: 'de',
    for: 'du',
    week: 'semaine',
    ok: "D'accord",
    minimum_slot_duration: `Durée des créneaux (La durée par défaut d'un RDV)`,
    setup_hours_of_operation_for_atleast_one_day: `Heures d'ouverture pendant au moins une journée`,
    and: 'et',
    patient_email_phone: 'coordonnees du patient',
    no_matches_found: 'Aucun résultat',
    enter_delay_time: 'Entrez le temps de retard en minutes',
    new_to: 'au',
    no_doctor_found: 'Aucun médecin trouvé',
    this_doctor: `Le docteur`,
    under_age: `n'accepte pas les patients de moins de`,
    not_allow_patient: `ne permet pas aux patients de prendre rendez-vous pour ce service`,
    not_new_patient: `n'accepte pas de nouveaux patients`,
    no_teleconsultation: `ne propose pas ce service par téléconsultation.`,
    upload_document: `Télécharger une ordonnance`,
    description: 'Description',
    date_hour: `Date et Horaire`,
    enter_reservation_mode: 'Entrez le mode de réservation en ligne',
    enter_consultation_mode: 'Entrez un mode de consultation',
    enter_sous_cate: 'Entrez une sous-catégorie',
    more: '',
    accept: 'acceptée',
    selected_special_exist: 'Des spécialités sélectionnées existent déjà pour ce médecin',
    emergencies: 'Urgences',
    select_add_speciality: 'Sélectionnez la spécialité que vous souhaitez ajouter',
    apt_confirm: "RDV confirmé",
    apt_late: "RDV retardé",
    apt_tele: "RDV téléconsultation",
    apt_finish: "RDV terminé",
    apt_cancel: "RDV annulé",
    only_file_type: "Seul les types de fichiers",
    are_allowed: "sont autorisés",
    price_mode: "Mode prix",
    fixed: 'Fixe',
    range: "Intervalle",
    appointment_completed_on: "Rendez-vous terminé le",
    teleconsultation: 'Téléconsultation',
    today: "Aujourd'hui",
    month: "Mois",
    day: "Jour",
    time_already_in_other_opening_hours: "Temps déjà dans d'autres heures d'ouverture",
    a: " un ",
    the: " le ",
    the1: " l'",
    there: " la ",
    make_an_appointment_earlier: 'Prendre rendez-vous plus tôt ?',
    receive_early_alert: 'Recevez une alerte si un créneau horaire est disponible avant',
    view_map: "Afficher la carte",
    consultation_in: "Consultations sur",
    location: "lieu",
    select_the_reason_for_consultation: 'Précisez votre motif d’examen',
    make_Appointment_teleconsultation: 'Prendre un rendez-vous en téléconsultation',
    doctor_busy_appointment: 'Le médecin est occupé en ce moment',
    service_book_between: `Le service que vous avez sélectionné ne peut être réservé qu'entre`,
    enter_payment_details: `Entrez les détails du paiement`,
    appointment_is_not_available: `Le rendez-vous n’est pas disponible`,
    delete_one_day: 'supprimer juste pour ce jour',
    delete_all: 'supprimer tout',
    see_more: `Voir plus`,
    see_less: 'Voir moins',
    insert_patient: 'Insérer le patient',
    gender: 'Genre',
    select_doctor_slot: 'Sélectionnez le médecin avec lequel vous souhaitez prendre rendez-vous',
    no_doctor_service: 'Aucun médecin trouvé pour ce motif de consultation',
    select_gender: 'Sélectionnez un sexe',
    contact_secretary_at: 'Veuillez contacter le secrétariat au : ',
    retard_not_accepte: `Le médecin n'accepte pas de retard`,
    retard_exceed: `Le délai demandé dépasse le délai imparti par le médecin.`,
    reason_for_exams: 'Motifs d’examens',
    add_document: 'Ajouter un document',
    leave_a_message: 'Laisser un message',
    read_only_access: `Accès en lecture seule`,
    close: 'Fermer',
    confirmed_cannot_delete: 'Les rendez-vous déjà confirmés ne peuvent pas être supprimés',
    choose_reasons: `Choisir le(s) motif(s) d'examens`,
    need_atleast_one: `Vous devez avoir au moins un service pour avancer`,
    follow_create_appointment: `Pour créer un rendez-vous, suivez les étapes ci-dessous dans le menu des paramètres`,
    create_configure_calendar: `Créer et paramétrer un agenda`,
    add_appointments: `Ajouter des rendez-vous`,
    enter_appointments: 'Entrer le rendez-vous',
    date_time: `Date et l'heure`,
    appointment_confirmed: `Votre rendez-vous est confirmé pour le `,
    no_tele_yet_contact: `Ce médecin ne prend pas actuellement en charge le service de téléconsultation. Veuillez contacter le cabinet du médecin pour obtenir de l'aide.`,
    verify_your_phone_number: "Vous n'avez pas vérifié votre numéro de téléphone. Pour continuer, veuillez vérifier votre numéro de téléphone en cliquant sur le bouton ci-dessous.",
    verify_your_phone_number_short: 'Vérifiez votre numéro de téléphone',
    verify: 'Vérifier',
    enter_your_otp: 'Veuillez entrer le mot de passe à usage unique pour vérifier',
    code_send_to: 'Veuillez entrer le code envoyé au *******{{code}}',
    dont_re_otp: "Vous n'avez pas reçu de code ?",
    resend: "Renvoyer",
    enter_valid_otp: "Entrez un OTP valide",
    invalid_phone_number: "Numéro de téléphone invalide",
    are_you_sure_cancel_apt: 'Etes-vous sûr de vouloir annuler ce rendez-vous',
    join: 'Joindre',
    slot_already_reserved_continue: 'Créneau déjà réservé. Continuez pour créer tout de même créer ce rdv',
    prescription_document: "Document de prescription",
    slot_already_reserved_continue: 'Créneau déjà réservé. Continuez pour ajouter tout de même ce RDV',
    mins: 'mins',
    remove_agenda_service: `Supprimer le motif d'examen`,
    confirm_remove_agenda_service: `Confirmer la suppression de ce motif d’examen « {{name}} » sachant qu’il est présent dans votre agenda ?`,
    opening_closing_time_slots: 'Paramètres agenda + Prise RDV',
    by_patient: 'par patient',
    service_no_tele: `Ce service n'est pas disponible en téléconsultation`,
    video_files_may_not_be_greater_than_12_mb: "Les fichiers vidéo ne peuvent pas dépasser 12 Mo",
    files_may_not_be_greater_than_10_MB: "La taille du fichier ne peut pas être supérieure à 10 Mo.",
    prescription_video: "Vidéo sur la prescription",
    prescription_image: "Image de la prescription",
    video: "Vidéo",
    image: "Image",
    document: "Document",
    please_upload_maximum_5_files: "Veuillez télécharger un maximum de 5 fichiers",
    view_profile: "Voir le profil",
    view_rdv: "Historique RDV",
    parking_address: "Parking adresse",
    parking_address_mandatory: "L'adresse du parking est obligatoire",
    select_create_review: "Sélectionner / Créer un examen",
    select_create_service: "Sélectionner / Créer un sous catégorie",
    choose_your_exams: "Choisissez vos motifs d'examens",
    'dd/mm/yyyy': '(jj/mm/aaaa)',
    absence_on: "Absence le",
    place_absence_time: "Signaler une absence dans l’Agenda ",
    place_urgent_time: "Marquer un créneau urgent pour l’Agenda ",
    place_break_time: "Inscrire une pause dans l’Agenda ",
    start_time: "Heure (début)",
    end_time: "Heure (fin)",
    short_duration: "Courte durée",
    full_day: "Journée entière",
    multiple_days: "Plusieurs jours",
    comments: "Commentaires",
    reason_for_absence_patient: "Motif de l'absence pour informer les patients *",
    block_patient: "Bloquer le patient",
    deblock_patient: "Débloquer le patient",
    unblock_patient: "Accepter de nouveau le patient",
    block_descrip_text: "Cette action limitera les possibilités de contact et de prises de rendez-vous entre le patient et le praticien.",
    unblock_descrip_text: "Cette action permettra à nouveau la prise de rendez-vous et la reprise de communication avec le praticien.",
    appointment_booking_is_not_available: "La prise de rendez-vous avec ce praticien est actuellement indisponible. Nous vous invitons à consulter un autre professionnel de santé pour votre suivi.",
    are_you_sure_block_patient: 'Êtes-vous sûr(e)de vouloir bloquer le patient ?',
    are_you_sure_unblock_patient: 'Êtes-vous sûr(e) de vouloir retirer le statut « Bloqué(e) » du patient ?',
    amount_to_pay_by_patient: 'Entrez un montant à payer par le patient',
    add_a_price: 'Ajouter un prix',
    currency: '€',
    mark_urgent_slot: "Définir créneau d'urgence",
    mark_absent_slot: "Signaler une absence",
    mark_pause_slot: "Inscrire une pause",
    urgent: "Urgence",
    pause: "Pause",
    absence: "Absence",
    do_you_want_move_appointment: "Voulez-vous déplacer ce rendez-vous ?",
    date_from: 'Du',
    date_from_sendMessage: 'Message envoyé le',
    absence_edit_error: `Vous ne pouvez pas modifier l'absent maintenant, puisque rdv appartient à cet absent et est déplacé vers une nouvelle date.`,
    move_appointment_from_to: 'Etes-vous sûr de vouloir déplacer votre rendez-vous prévu le ',
    reschedule_appointment: 'Reprogrammer un rendez-vous',
    leave: "Congés",
    sick_leave: "Congés maladie ",
    training: "Formation",
    emergencies: "Urgence",
    start: "début",
    choose_reason_absence: "Choisissez une raison d'absence",
    manage_openings: "Définir créneau d'urgence",
    appointment_been_confirmed: "Votre rendez-vous a été confirmé",
    select_date_time_to_move: "Sélectionnez la date et l’horaire auxquels vous souhaitez déplacer le rendez-vous :",
    agenda_list: "Liste de l'agenda",
    popup_blocked_disable_blocker: "La fenêtre pop-up a été Bloqué(e). Veuillez désactiver votre bloqueur de pop-up et réessayer.",
    make_apt: "Prendre un RDV",
    change_opening_times: "Modifier les plages d'ouverture",
    patient_blocked: "Le patient est actuellement Bloqué(e).",
    accept_patient_again: "Souhaitez-vous accepter de nouveau le patient ?",
    blocked: 'Bloqué(e)',
    apt_no_cancel_before: "Le rendez-vous ne peut être annulé avant une heure de l'heure prévue.",
    only_type_files_are_allowed: "Seuls les fichiers de type {{types}} sont autorisés",
    honored: 'honorés',
    future: 'futurs',
    absent: 'absents',
    cancelled: 'annulés',
    deleted: 'supprimés',
    zoom_user_does_not_exist: `Zoom - L'utilisateur n'existe pas : {{user}}`,
    you_are_logged_as: 'Vous êtes connecté en tant que {{userType}}',
    no_result_found_search: `Aucun résultat trouvé. Essayez d'ajuster votre recherche ou vos filtres.`,
    enter_price: "Entrez le prix",
    select_date_time_before_submit: "Sélectionnez la nouvelle date et heure de début avant de soumettre",
    already_have_appointment: 'Un rendez-vous est déjà programmé pour une « {{name}} » le {{date}} à {{time}}.',
    are_you_sure_proceed: 'Êtes-vous sûr(s) de vouloir continuer ?',
    possible_duplicate_apt: 'Possible double RDV',
    select_agenda_to_move: `Sélectionnez l'agenda pour lequel vous souhaitez déplacer le RDV :`,
    select_agenda_to_book: `Sélectionnez l'agenda pour lequel vous souhaitez afficher la prochaine disponibilité :`,
    other_practicioner: 'Autre praticien(ne)',
    search_patient: 'Recherche Patient',
    search_patient_rdv: 'Recherche Patient (RDV)',
    next_free_slot_on: 'Prochain créneau libre le ',
    next_availability: 'Prochaine disponibilité',
    all_my_team_agenda: `Tous les agendas de mon équipe`,
    choose_an_appointment: `Choisissez un Rendez-vous`,
    are_you_sure_book_appointment: `Confirmez vous le rendez-vous du {{date}} à {{time}}`,
    outside_proposed_opening_hours: "En dehors des horaires proposés",
    enter_valid_email: 'Entrez une adresse e-mail valide',
    enter_valid_dob: 'Entrez une date de naissance valide',
    invalid_email_domain: "Le domaine email n'est pas autorisé",
    select_appointment_mode_date: `Sélectionnez la date et l'horaire auxquels vous souhaitez déplacer le rendez-vous`,
    are_you_sure_you_want_to_deplacer_appointment_from_to: 'Rendez-vous déplacé au : {{date}} à {{time}}',
    done: 'Fait',
    return_patient_file: "Retour dossier patient",
    no_availability: 'Pas de disponibilité',
    return_to_calendar: "Retour à l'agenda",
    at1: 'à',
    app_name: 'MediKaLlink',
    default_color: 'Couleur par défaut',
    deletion_of: `Suppression "{{name}}"`,
    rdv_deleted: 'Rendez-vous supprimé',
    cant_view_deleted_appointment: 'Vous ne pouvez pas consulter un rendez-vous supprimé.',
    moving_an_appointment_click_to_cancel: 'Déplacement du RDV en cours. Cliquer ici pour annuler',
    confirm_date_and_time: 'Confirmation de date et heure',
    moving_the_appointment: 'Déplacement du RDV',
    original_appointment: "RDV d'origine",
    service: "Motif",
    contact: "Contact",
    send_message_to_patients: 'Envoyer un message aux patients',
    all_day: 'Toute la journée',
    message: 'Message',
    send: 'Envoyer',
    other: 'Autre',
    send_immediately: ' Envoyer immédiatement',
    free_text: 'Texte libre',
    delete_absence: "Suppression de l'Absence",
    delete_pause: "Suppression de la Pause",
    delete_urgent: "Suppression de l'Urgence",
    delete_opening: "Supprimer de l'Ouverture",
    create_new_service: 'Créer une sous catégorie',
    create_new_category: "Créer un nouveau motif d'examen",
    from_to: 'du {{from}} au {{to}}',
    from1: 'du {{from}}',
    apt_date: 'Date de RDV',
    to_this_patient: 'A ce patient',
    to_the_doctor: 'Au médicin',
    to_other_correspondent: 'À un autre correspondant',
    send_a_message: 'Envoyer un message',
    instructions: "Instructions",
    delete_instruction: "Are you sure you want to delete this instruction ?",
    add_an_internal_note: "Ajouter une note interne",
    matriculeINS: "Matricule INS",
    INSEE_oid: "oid",
    add_instruction: "Ajouter une instruction",
    edit_instruction: "Modifier une instruction",
    title_required: "Titre obligatoire",
    description_required: "Description obligatoire",
    insee_verification: "INSEE verification",
    list_of_birth_names: "Liste des prénoms de naissance",
    first_name_used: "Prénom utilisé",
    last_name_used: "Nom utilisé",
    supporting_document: "Pièce justificative",
    place_of_birth_insee: "Lieu de naissance(code INSEE)",
    national_identity_card: "Carte nationale d’identité",
    passport: "Passeport",
    residence_permit: "Titre de séjour",
    eIDAS: "eIDAS",
    trusted_third_party: "Tiers de confiance",
    supporting_document: "Pièce justificative",
    search_by_name_city_name: "Rechercher une ville avec un nom",
    no_city_found: "Aucune ville trouvée",
    enter_valid_matriculeINS: "Invalid Matricule INS",
    enter_valid_oid: "entrer un oid invalide",
    the_format_of_the_insi_oid_field_is_incorrect: "Le format du champ insi oid est incorrect.",
    internal_notes: 'Note interne',
    payment_failed: 'Paiement échoué',
    paid: 'Payé',
    delete_internal_note: "Suppression de la note interne",
    are_you_sure_you_want_to_delete_this_note: 'Êtes-vous sûr de vouloir supprimer cette note ?',
    carte_vitale_data_did_not_match_to_the_patient_data: 'Les données de la carte vitale ne correspondent pas aux données du patient',
    payment_cancelled: "Paiement annulé",
    orisha_patient_profile_incomplete: 'Votre profil patient est incomplet sur le portail Orisha. Vous devez le compléter avant de continuer.',
    do_you_wish_to_continue: 'Souhaitez-vous mettre à jour votre profil maintenant ?',
    incomplete_patient_profile: 'Profil du patient incomplet',
    no_inc_token_found_for_patient: 'Aucune identification INS trouvée pour ce patient.',
    patient_not_found_create_orisha_patient_profile: 'Il semble que le patient ne se soit pas inscrit à Orisha auparavant. Souhaitez-vous créer un profil Orisha pour lui ?',
    do_you_have_a_vitale_card: 'Avez vous une carte vitale ?',
    orisha: 'Orisha',
    remind_me_before: "La veille du rendez-vous",
    recurrence: "Récurrence",
    message_sent_on: "Message envoyé",
    apt_day: 'Le jour du rendez-vous ',
    choose: 'Choisir',
    select_atleast_one_act: 'Sélectionnez au moins un acte',
    note_of_day: 'Note du jour',
    now: 'Maintenant',
    notify_patient_after_deletion: 'Avertir le patient de la suppression de ce rendez-vous',
    edit_patient: 'Modifier le patient',
    edit: "Modifier",
    are_you_sure_want_to_change_appointment_date: "Etes-vous sûr de vouloir modifier la date du rendez-vous ?",
    change_status: "Modifier le statut",
    change_time: "Modifier l'heure",
    receive_notification_via: 'Recevoir les notifications de RDV via : SMS / E-mail ',
    mail: 'Email',
    sms: 'SMS',
    update: 'Mise à jour',
    in_off: 'Cab',
    in_tele: 'Tcs',
    at_hm: 'Dom',
    opening_hours_info_l1: 'Définissez les horaires de vos consultations; tous modes confondus',
    opening_hours_info_l2: '(en cabinet, à domicile et en téléconsultation)',
    opening_hours_info_l3: 'A l’étape suivante vous pourrez définir les créneaux des consultations',
    opening_hours_info_l4: 'en cabinet et à domicile, et des téléconsultations',
    normal: 'Normales',
    ald: 'ALD',
    cmu: 'CMU-C',
    ame: 'AME',
    to_support: "Au support",
    to_another_correspondent: "A un autre correspondant",
    to_my_team: "À mon équipe",
    team: "Équipe",
    consultation_mode_not_supported: "Mode de consultation non pris en charge",
    dd_mm_yyyy: "jj/mm/aaaa",
    verify_your_email1: 'Veuillez vérifier votre adresse e-mail pour prendre rendez-vous.',
    verify_your_email2: 'Un lien de confirmation vous a été envoyé.',
    resend_the_link: 'Renvoyer le lien',
    send_the_link: 'Envoyer le lien',
    enter_your_phone_number: 'Saisissez votre numéro de mobile',
    something_went_wrong: 'Quelque chose s’est mal passé',
    enter_valid_phone_number: 'Veuillez saisir un numéro de téléphone valide.',
    teleconsultation_invitation: 'Invitation à la téléconsultation',
    accept: "Accepter",
    decline: "Refuser",
    invite_to_continue_discussion: "{{doctor_name}} vous invite à poursuivre la discussion en téléconsultation le {{date}} à {{time}}",
    the_fee_is: "La cotisation est de {{fee}}",
    do_you_accept: "Acceptez-vous ?",
    no_teleconsultation_invitation_found: "Aucune invitation à la téléconsultation trouvée",
    pending: "En attente",
    modification_on_apt_of_patient_at: "Modification du RDV de ",
    deletion_on_apt_of_patient_at: "Suppression du RDV de ",
    apt_booked_for: "Rendez-vous réservé pour ",
    from_to: " {{from}} à {{to}}",
    end: "Fin",
    instead_of: "au lieu de",
    referant: "Adressé par",
    file_added: "Fichier ajouté",
    all_agendas: "Tous les agendas",
    this_appointment_was_made_within_the_last_48_hours: "Ce RDV a été pris dans les dernières 48h",
    appointment_status_changed: "Le statut du rendez-vous a été modifié de {{old}} à {{new}}.",
    appointment_status: "Le statut du rendez-vous est {{new}}.",
    appointment_actions_history: "Historique des actions du rendez-vous",
    file_removed:"Le fichier {{fileName}} a été supprimé.",
    end_times:"heure de fin",
    start_times:"heure de début",
    appointment_service_changed: "Le service du rendez-vous a été modifié de {{old}} à {{new}}.",
    appointment_consultation_changed: "La consultation du rendez-vous a été modifiée de {{old}} à {{new}}.",
    file_removed:"Le fichier {{fileName}} a été supprimé.",
    appointment_agenda_changed:"L'ordre du jour des rendez-vous a été modifié {{old}} à {{new}}."
} 
